// extracted by mini-css-extract-plugin
export default {"colorMystic":"#E1E8ED","filterHotelName":"O_oOJer04N2O3YkM5uEJ","filterHotelNameInput":"LKJpJOJtKEtqwKaLst0d"};